export type VAVideoFailureReason = "not_found" | "network_error";

export class VAVideoFetchError extends Error {
  constructor(
    public readonly reason: VAVideoFailureReason,
    message: string,
  ) {
    super(message);
    this.name = "VAVideoFetchError";
  }
}

export interface VAVideoFailedEntry {
  videoName: string;
  language: string;
  reason: VAVideoFailureReason;
  error: string;
}

export interface VAVideoDownloadResult {
  failedFiles: VAVideoFailedEntry[];
}
